import React, {Fragment} from 'react';
import './contracts.scss';
import {Link} from "react-router-dom";
import Icons from "../../../../../Commun/Icon/Icon";
import ListeSouscriptionDevis from "./ListeSouscriptionDevis/ListeSouscriptionDevis";
import {HOST_MB} from "../../../../../../constants/constants";
import moment from 'moment';
import Swal from "sweetalert2";
import _ from "lodash";

const Contracts = (props) => {
    const {
        contracts,
        souscriptionGenerale,
        subscribeLinks,
        postTerminateAssuranceTransitoire,
        query_terminate_assu_transitoire
    } = props;

    const handleTerminateAssuranceTransitoire = (contractId) => {
        Swal.fire({
            title: 'Confirmation',
            text: 'Confirmez-vous avoir vendu votre ancien véhicule ? Cela mettra fin à l\'assurance transitoire.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Oui, je confirme',
            cancelButtonText: 'Annuler'
        }).then((result) => {
            if (result.isConfirmed) {
                postTerminateAssuranceTransitoire({
                    query: _.replace(query_terminate_assu_transitoire, '{id}', contractId),
                });
            }
        });
    };

    const hasActiveTransitoire = (contract) => {
        return (
            contract.old_vehicule?.immatriculation &&
            contract.vehicule.vente_old_vehicule !== 'T' &&
            moment(contract.old_vehicule.date_fin_piece).isAfter(moment())
        );
    };

    return (
        <div className={'bloc-white contracts col-xl-11 col-md-12'}>
            <h2 className={'title-bloc d-inline-block'}>Mes contrats</h2>
            <Link to={'/mes-contrats'} className={'link-underline d-inline-block float-right'}>Voir tout</Link>

            {contracts && contracts.map((c, i) => (
                <Fragment key={i}>
                    <div className={'contract row'}>
                        <div className={'detail col-12 col-md-9'}>
                            <p>Contrat n°{c.numeroPolice}</p>
                            <small>{c.title} / {c.situation.statut}</small>
                        </div>
                        <div className={'col-12 col-md-3 align-right'}>
                            <Link to={`/mes-contrats/mon-contrat/${c.id}`} className={'link-detail'}>Voir le détail <Icons icon={'chevrondroite'} fontSize={12} /></Link>
                        </div>
                    </div>
                    {hasActiveTransitoire(c) && (
                        <div className="transitoire-block my-3 p-3 border rounded bg-light">
                            <div className="">
                                <p className="font-weight-bold mb-2">
                                    Vous venez de changer le véhicule assuré sur votre contrat.
                                </p>
                                <p className="mb-3">
                                    Avez-vous vendu votre ancien véhicule {c.old_vehicule.marque} {c.old_vehicule.modele} ?
                                </p>
                                <div className="d-flex">
                                    <button
                                        className="btn btn-primary mr-3"
                                        onClick={() => handleTerminateAssuranceTransitoire(c.id)}
                                    >
                                        OUI j'ai vendu ce véhicule
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                </Fragment>
            ))}

            { souscriptionGenerale && HOST_MB === 43397 ?
                <ListeSouscriptionDevis subscribeLinks={subscribeLinks}/>
                : '' }
        </div>
    );
};

export default Contracts;